export const DESCRIPTION_MAX_CHARACTERS = 4000;
export const DESCRIPTION_MIN_CHARACTERS = 30;
